<template>
  <div class="dictionary-wrap">
    <!-- PCの場合 -->
    <div v-if="isPc">
      <div class="dictionary-header">
        <!-- 検索ワード入力 -->
        <div class="dictionary-input">
          <input type="text" placeholder="調べたい英単語を入力" v-model="inputWord" @keypress.enter="doSearch()" />
          <button @click="doSearch()"><span class="icon-search"></span>検索</button>
        </div>
        <!-- 単語エリア -->
        <div class="dictionary-word">
          <div v-for="(word, index) in wordList" @click="getDictionary(word, index)" class="search-word">
            <a :class="{search_word_active: index == currentWordIndex}">{{ word }}</a>
          </div>
        </div>
      </div>
      <div class="dictionary-main">
        <!-- 見出し語検索(成句エリア1) -->
        <div class="dictionary-result-sub">
          <div class="dictionary-use">
          <p v-if="currentWord.length != 0" class="dictionary-title">{{ currentWord }}を使った表現</p>
            <div v-if="entryWordResponseJson == null">
              <p>{{ entryWordError }}</p>
            </div>
            <div v-else>
              <div v-for="(setPhrase, index) in setPhraseList" @click="showSetPhraseResult(index)" class="dictionary-list">
                <div v-for="linesData in setPhrase.linesData">
                  <div v-for="lines in linesData">
                    <a :class="{dictionary_include_text_active: currentSetPhraseIndex == index}" v-html="changeTag(lines.text)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 成句・用例検索(成句エリア2) -->
          <div class="dictionary-include">
            <p v-if="currentWord.length != 0" class="dictionary-title">{{ currentWord }}を含む表現</p>
            <div v-if="phraseResponseJson == null">
              <p>{{ phraseError }}</p>
            </div>
            <div v-else>
              <div v-for="(phrase, index) in phraseResponseJson" @click="showPhraseResult(index)" class="dictionary-list">
                <a :class="{dictionary_include_text_active: currentPhraseIndex == index}" v-html="changeTag(phrase.text)" />
              </div>
            </div>
            <!-- 結果 -->
          </div>
        </div>
        <!-- 見出し語結果 -->
        <div class="dictionary-result-main">
          <div v-if="phraseResult == null" class="dictionary-result-main-inner">
            <div v-if="entryWordResponseJson == null">
              <p>{{ entryWordError }}</p>
            </div>
            <div v-else-if="setPhraseResult == null">
              <WordResult :dataList="wordResultList" />
            </div>
            <div v-else>
              <SetPhraseResult :data="setPhraseResult" />
            </div>
          </div>
          <div v-else class="area-phraseresult">
            <!-- 成句・用例結果 -->
            <div class="dictionary-result-main-inner">
              <PhraseResult :data="phraseResult" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- モバイルの場合 -->
    <div v-else class="dictionary flexcenter" :class="{'dictionary-modal': isModal}">
      <transition>
        <div class="dictionary-dialog">
          <button v-if="isModal" class="modal-close" @click="closeDictionary()"></button>
          <div class="dictionary-dialog-inner">
            <div class="dictionary-header flexbetween">
              <div v-if="showSearchWord">
                <!-- 検索ワード入力 -->
                <div class="dictionary-input">
                  <input type="text" placeholder="調べたい英単語を入力" v-model="inputWord" @keypress.enter="doSearch()" />
                  <button @click="doCancel()" class="button-cancel">キャンセル</button>
                  <div v-if="!isModal" class="dictionary-close" @click="closeDictionary()"></div>
                </div>
              </div>
              <div v-else class="dictionary-word">
                <!-- 単語エリア -->
                <div class="search-word-wrap">
                  <div v-for="(word, index) in wordList" @click="getDictionary(word, index)" class="search-word">
                    <a :class="{search_word_active: index == currentWordIndex}">{{ word }}</a>
                  </div>
                </div>
                <button @click="doShowSearchWord()" class="button-search-s"><span class="icon-search"></span></button>
                <div v-if="!isModal" class="dictionary-close" @click="closeDictionary()"></div>
              </div>
            </div>
            <!-- 結果 -->
            <div class="dictionary-main">
              <div class="dictionary-main-inner">
                <div class="swiper-dictionary swiper-container">
                  <div class="swiper-wrapper">
                    <!-- 見出し語結果一覧(単語) -->
                    <div class="swiper-slide">
                      <div v-if="entryWordResponseJson == null">
                        <p>{{ entryWordError }}</p>
                      </div>
                      <div v-else>
                        <WordResult :dataList="wordResultList" />
                      </div>
                    </div>
                    <!-- 見出し語結果一覧(成句) -->
                    <div class="swiper-slide">
                      <p v-if="currentWord.length != 0" class="bold mb10 font-large">{{ currentWord }}を使った表現</p>
                      <div v-if="entryWordResponseJson == null">
                        <p>{{ entryWordError }}</p>
                      </div>
                      <div v-else>
                        <template v-for="setPhrase in setPhraseList">
                          <SetPhraseResult :data="setPhrase" />
                        </template>
                      </div>
                    </div>
                    <!-- 成句・用例結果一覧 -->
                    <div class="swiper-slide">
                      <p v-if="currentWord.length != 0" class="bold mb10 font-large">{{ currentWord }}を含む表現</p>
                      <div v-if="phraseResponseJson == null">
                        <p>{{ phraseError }}</p>
                      </div>
                      <div v-else>
                        <template v-for="phrase in phraseResponseJson">
                          <PhraseResult :data="phrase" />
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div><!--dictionary-main-->
            <div v-show="isClickSearch" class="swiper-pagination"></div>
          </div>
        </div>
      </transition>
    </div>

    <!-- エラーダイアログ -->
    <ErrorDialog v-if="showErrorDialog" @close="showErrorDialog = false" :message="errorMessage" :buttonKind="errorButtonKind" :platformName="platformName" :routeQuery="{ showDictionary: true }" />
  </div>
</template>

<script>
import common from '@/mixin/common';
import http from '@/mixin/http';
import ErrorDialog from '@/components/Error';
import WordResult from '@/components/dictionary/WordResult';
import SetPhraseResult from '@/components/dictionary/SetPhraseResult';
import PhraseResult from '@/components/dictionary/PhraseResult';
import * as constants from '@/mixin/constants';

const SEARCEMODE_ENTRYWORD = "1";
const SEARCEMODE_PHRASE = "2";
const RANK_IMG_SRC_PC = "static/images/icon/png/dictionary_rank_*_pc.png";
const RANK_IMG_SRC_MOBILE = "static/images/icon/png/dictionary_rank_*_mobile.png";
const DOCUMENT_TITLE_DICTIONARY = "英和辞書";
const DOCUMENT_TITLE_DEFAULT = "Rosetta Stone";

export default {
  name: 'dictionary',
  props: {
    platformName: String,
    isModal: Boolean
  },
  data: function () {
    return {
      swiper: null,                         // スライダー
      isPc: true,
      isClickSearch: false,
      // 検索対象単語
      wordList: [],
      currentWord: "",
      currentWordIndex: -1,
      inputWord: "",
      // APIのレスポンス
      entryWordResponseJson: null,
      phraseResponseJson: null,
      entryWordError: "",
      phraseError: "",
      // 見出し語の表示
      setPhraseList: [],
      wordResultList: [],
      setPhraseResult: null,
      currentSetPhraseIndex: -1,
      // 成句・用例の表示
      phraseResult: null,
      currentPhraseIndex: -1,
      // エラー表示
      showErrorDialog: false,
      errorMessage: "",
      errorButtonKind: "",
      // 検索ワード入力欄表示
      showSearchWord: true
    }
  },
  components: {
    ErrorDialog,
    WordResult,
    SetPhraseResult,
    PhraseResult
  },
  mixins: [
    common,
    http
  ],
  created: function () {
    this.log("Dictionary start created");

    if (this.isEnvironmentPc()) {
      this.isPc = true;
      document.title = DOCUMENT_TITLE_DICTIONARY;

      var att = document.getElementsByTagName("body")[0].getAttribute("class");
      if(att != null && att.length != 0) {
        att = att.concat(" window-dictionary");
      } else {
        att = "window-dictionary";
      }
      document.getElementsByTagName("body")[0].setAttribute("class", att);
    } else {
      this.isPc = false;
    }
  },
  mounted: function () {
    this.log("Dictionary start mounted");

    // GoogleAnalyticsページビューヒット送信
    rosettaGA.sendPageView(constants.GA_PAGEVIEW.TITLE.DICTIONARY, constants.GA_PAGEVIEW.PAGE.DICTIONARY);

    if(this.isPc) {
      // ウィンドウサイズ変更イベント
      var self = this;
      window.addEventListener('resize', function (event) {
        self.setHeight();
      });

      // ローカルストレージ操作初期化処理
      storage_wrapper.initialize(this.$parent.iframeId, process.env.WEB_API_ORIGIN);
    } else {
      this.initSwiper();
    }

    var word = this.$route.query.word;
    if(word) {
      this.inputWord = word;
      this.doSearch();
    }
  },
  beforeDestroy: function() {
    this.log("Dictionary start beforeDestroy");

    if(this.isPc) {
      var att = document.getElementsByTagName("body")[0].getAttribute("class");
      att = att.replace(" window-dictionary", "");
      document.getElementsByTagName("body")[0].setAttribute("class", att);

      window.removeEventListener('resize', this);

      document.title = DOCUMENT_TITLE_DEFAULT;
    } else {
      this.swiper.destroy();
    }
  },
  methods: {
    /**
     * Swiperの初期化
     */
    initSwiper: function() {
      this.log("Dictionary start initSwiper");

      // スライダーの準備
      this.swiper = new Swiper('.swiper-dictionary', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 0,
        initialSlide: 0,
        allowTouchMove: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        on: {
          slideChangeTransitionStart: function() {
            // ページトップへ
            $(".dictionary-main-inner").prop("scrollTop", 0);
          }
        }
      })
    },
    /**
     * 表示時を初期化
     */
    showInit: function() {
      if(!this.isPc) {
        this.swiper.slideTo(0);
      }

      this.entryWordResponseJson = null;
      this.phraseResponseJson = null;
      this.entryWordError = "";
      this.phraseError = "";

      this.setPhraseList.splice(0);
      this.wordResultList.splice(0);
      this.setPhraseResult = null;
      this.currentSetPhraseIndex = -1;

      this.phraseResult = null;
      this.currentPhraseIndex = -1;

      // css調整
      this.$nextTick(function () {
        this.setHeight();
      });
    },
    /**
     * 見出し語検索、成句・用例検索を行う
     */
    getDictionary: async function(word, index) {
      this.log("Dictionary start getDictionary");

      this.currentWord = word;
      this.currentWordIndex = index;
      this.showInit();

      var accessKey = await storage_wrapper.getRsAccessKey();

      var self = this;
      Promise.resolve().then(function() {
        return self.doDictionary(word, SEARCEMODE_ENTRYWORD, accessKey);
      }).then(function() {
        return self.doDictionary(word, SEARCEMODE_PHRASE, accessKey);
      }).catch(function(err) {
        self.errorMessage = err.errMessage;
        self.errorButtonKind = err.errButtonKind;
        self.showErrorDialog = true;
      }).then(function() {
        if(!self.showErrorDialog) {
          if(self.entryWordError.length == 0) {
            // 見出し語表示を作成
            self.createWordData(self.entryWordResponseJson);
            self.createSetPhraseData(self.entryWordResponseJson);
          }
        }

        self.$nextTick(function () {
          // androidアプリで単語リストから遷移してきた(Getパラメータがある)場合、
          // 検索結果が表示されないので、css調整で描画を更新する
          self.setHeight();
        });
      });
    },
    /**
     * 見出し語(単語)の表示データを作成
     */
    createWordData: function(responseJson) {
      var self = this;

      if(responseJson == null) {
        return;
      }

      responseJson.forEach(function(element) {
        var word = element.word;
        var pronunciation = "[" + element.pronunciation + "]";

        // rankアイコンの設定
        var rank = "";
        if(element.alcRank >= 1 && element.alcRank <= 12) {
          if(self.isPc) {
            rank = RANK_IMG_SRC_PC.replace("*", element.alcRank);
          } else {
            rank = RANK_IMG_SRC_MOBILE.replace("*", element.alcRank);
          }
        }

        var variationData = "";
        var partOfSpeechData = [];
        var partOfSpeeches = element.partOfSpeeches;
        partOfSpeeches.forEach(function(speechElement) {
          var partOfSpeech = speechElement.partOfSpeech;
          var variation = speechElement.variation;
          var linesData = [];

          var classes = speechElement.classes;
          classes.forEach(function(classElement) {
            if(classElement.phraseBool == false) {
              linesData.push(self.createLineData(classElement.lines));
            }
          })

          var data = {partOfSpeech: partOfSpeech, linesData: linesData};
          partOfSpeechData.push(data);

          // partOfSpeechとvariationの一覧作成
          variationData = variationData.concat(partOfSpeech);
          if(variation != null) {
            var str = self.getWordFromVariation(variation);
            variationData = variationData.concat(str);
          }
        })

        var data = { word: word, pronunciation: pronunciation, alcRank: rank, variationData: variationData, partOfSpeeches: partOfSpeechData };
        self.wordResultList.push(data);
      });
    },
    /**
     * variationから単語を取得する
     */
    getWordFromVariation: function(variation) {
      var result = "";

      // 発音記号を削除
      var str = variation.replace(/｛(.*?)｝/g, "");

      var vertical = str.split("｜");
      for(var i = 0; i < vertical.length; i++) {
        var slash = vertical[i].split("／");
        slash.forEach(function(slashElement) {
          var comma = slashElement.split(",");
          comma.forEach(function(commaElement) {
            // "(())"を取得
            var match = commaElement.match(/\(\((.*?)\)\)/g);
            // 英字以外を削除
            var res = commaElement.replace(/[^a-zA-Zɡ]/g, "");
            // 整形
            if(match != null) {
              res = match[0].concat(res);
            }

            if(result.length != 0) {
              result = result.concat(", ");
            }
            result = result.concat(res);
          })
        })
      }

      return result;
    },
    /**
     * 見出し語(成句)の表示データを作成
     */
    createSetPhraseData: function(responseJson) {
      var self = this;

      if(responseJson == null) {
        return;
      }

      responseJson.forEach(function(element) {
        var partOfSpeeches = element.partOfSpeeches;

        partOfSpeeches.forEach(function(speechElement) {
          var classes = speechElement.classes;

          classes.forEach(function(classElement) {
            if(classElement.phraseBool == true) {
              var lines = classElement.lines;

              lines.forEach(function(lineElement) {
                var word = lineElement.text;
                if(word != null) {
                  var lineChildrenData = self.createLineChildrenData(lineElement.lineChildren);
                  var linesData = [{ text: word, lineChildren: lineChildrenData }];

                  var data = { linesData: [linesData] };
                  self.setPhraseList.push(data);
                }
              })
            }
          })
        })
      });
    },
    /**
     * lineデータを作成
     */
    createLineData: function(lines) {
      var result = [];

      var self = this;
      lines.forEach(function(element) {
        var lineChildrenData = self.createLineChildrenData(element.lineChildren);

        var data = { text: element.text, lineChildren: lineChildrenData };
        result.push(data);
      });

      return result;
    },
    /**
     * lineChildrenデータを作成
     */
    createLineChildrenData: function(lineChildren) {
      var result = [];

      var self = this;
      lineChildren.forEach(function(element) {
        var text = element.childText;
        var exampleData = self.createExampleData(element.examples);

        var data = { childText: text, examples: exampleData };
        result.push(data);
      });

      return result;
    },
    /**
     * exampleデータを作成
     */
    createExampleData: function(examples) {
      var ex = "";
      var columns = [];

      var self = this;
      examples.forEach(function(element) {
        var data = "・" + element.exampleEn + "/" + element.contentJa;
        ex = ex.concat(data);

        element.columns.forEach(function(columnElement) {
          columns.push(columnElement);
        })
      });

      var result = {example: ex, columns: columns};
      return result;
    },
    /**
     * 見出し語が押下された場合、結果エリアを更新
     */
    showSetPhraseResult: function(index) {
      this.log("Dictionary start showSetPhraseResult index: " + index);

      this.phraseResult = null;
      this.currentPhraseIndex = -1;
      this.currentSetPhraseIndex = index;
      this.setPhraseResult = this.setPhraseList[index];
    },
    /**
     * 成句・用例が押下された場合、結果エリアを更新
     */
    showPhraseResult: function(index) {
      this.log("Dictionary start showPhraseResult index: " + index);

      this.setPhraseResult = null;
      this.currentSetPhraseIndex = -1;
      this.currentPhraseIndex = index;
      this.phraseResult = this.phraseResponseJson[index];
    },
    /**
     * 検索ボタン押下
     */
    doSearch: function() {
      this.log("Dictionary start doSearch");

      this.errorMessage = "";

      if(this.inputWord.length == 0) {
        return;
      }

      // 入力値を確認
      var list = this.checkParam(this.inputWord);
      if(list.length != 0) {
        // 表示更新
        if(!this.isPc) {
          this.swiper.allowTouchMove = true;
        }
        this.wordList.splice(0);
        this.wordList = list.slice();
        this.showSearchWord = false;
        this.isClickSearch = true;

        this.getDictionary(this.wordList[0], 0);
      } else {
        if(this.errorMessage.length != 0) {
          // キーボードを閉じる
          document.activeElement.blur();

          // エラー表示
          this.errorButtonKind = "";
          this.showErrorDialog = true;
        }
      }

      this.inputWord = "";

      // css調整
      this.$nextTick(function () {
        this.setHeight();
      });
    },
    /**
     * 入力値の確認
     */
    checkParam: function(param) {
      var result = [];
      var len = 0;

      var splitStr = param.split(" ");
      for(var i = 0; i < splitStr.length; i++) {
        if(splitStr[i].length != 0) {
          if(splitStr[i].search("[^a-zA-Z_0-9!\"#\\$%&'\\(\\)\\+,\\-\\./:;<=>\\?@\\[\\\\\\]\\^_`\\{\\｜\\}~]") == -1) {
            // 21文字以上か確認
            if(splitStr[i].length > 20) {
              this.errorMessage = constants.ERR_DICTIONARY;
            } else {
              // 総文字数の最大値を確認
              len = len + splitStr[i].length;
              if(len > 200) {
                return result;
              }

              result.push(splitStr[i]);
            }
          } else {
            if(this.errorMessage.length == 0) {
              this.errorMessage = constants.ERR_DICTIONARY_INPUT;
            }
          }
        }
      }

      return result;
    },
    /**
     * キャンセルボタン押下
     */
    doCancel: function() {
      this.log("Dictionary start doCancel");
      this.showSearchWord = false;
      this.inputWord = "";

      // css調整
      this.$nextTick(function () {
        this.setHeight();
      });
    },
    /**
     * 検索ワード入力欄を表示
     */
    doShowSearchWord: function() {
      this.log("Dictionary start doShowSearchWord");
      this.showSearchWord = true;

      // css調整
      this.$nextTick(function () {
        this.setHeight();
      });
    },
    /**
     * 辞書APIの実行
     */
    doDictionary: function(word, mode, accessKey) {
      this.log("Dictionary start doDictionary word: " + word + ", mode: " + mode);

      var self = this;
      return new Promise(function(resolve, reject) {
        self.dictionary(word, mode, accessKey).then(function(response) {
          self.log("Dictionary dictionary resultCode: " + response.result_code);
          switch (response.result_code) {
            case "OK":
              if(response.search_mode == SEARCEMODE_ENTRYWORD) {
                self.entryWordResponseJson = response.search_result;
              } else {
                self.phraseResponseJson = response.search_result;
              }
              resolve();
              break;
            case "INFO_INVALID_ACCESSKEY":
              var errMessage = response.result_code;
              var errButtonKind = constants.ERROR_BUTTON_KIND_LOGIN;
              reject({ errMessage: errMessage, errButtonKind: errButtonKind });
              break;
            case "INFO_INVALID_WORD":
              var errMessage = constants.ERR_DICTIONARY_INVALID_WORD;
              if(response.search_mode == SEARCEMODE_ENTRYWORD) {
                self.entryWordError = errMessage;
              } else {
                self.phraseError = errMessage;
              }
              resolve();
              break;
            default:
              var errMessage = constants.ERR_DICTIONARY_UNKNOWN.replace(/x/, response.result_code);
              if(response.search_mode == SEARCEMODE_ENTRYWORD) {
                self.entryWordError = errMessage;
              } else {
                self.phraseError = errMessage;
              }
              resolve();
              break;
          }
        }).catch(function(err) {
          var errMessage = constants.ERR_UNKNOWN;
          if(mode == SEARCEMODE_ENTRYWORD) {
            self.entryWordError = errMessage;
          } else {
            self.phraseError = errMessage;
          }
          resolve();
        });
      });
    },
    /**
     * css調整
     */
    setHeight: function() {
      this.log("Dictionary start setHeight");

      var headerHeight = $(".dictionary-header").innerHeight();

      var mainHeight = 0;
      if(this.isPc) {
        var windowHeight = window.innerHeight;
        mainHeight = windowHeight - headerHeight;
      } else {
        var dialogHeight = $(".dictionary-dialog").innerHeight();
        var paginationHeight = $(".swiper-pagination").innerHeight();

        mainHeight = dialogHeight - headerHeight - paginationHeight;
      }

      $(".dictionary-main").css({
        "height" : mainHeight + "px",
        "margin-top" : headerHeight + "px",
      });
    },
    /**
     * 辞書画面を閉じる
     */
    closeDictionary: function() {
      try {
        window.Phone.CloseDictionary();
      }
      catch (err) {
        this.log("closeDictionary Error:" + err);
        this.$emit('close');
      }
    }
  }
};
</script>

<style lang="scss">
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// Dictionary.vue?28945628